/**
 * Locale-aware duration string formatter.
 *
 * The LLM-translated `duration_xx` fields sometimes keep the English unit
 * suffix "h" / "hours" / "hrs" even on non-Latin-script cards, which looks
 * wrong next to Japanese / Chinese / Russian / Ukrainian text
 * (e.g. "3,5h" on a Japanese card should read "3,5時間").
 *
 * This helper post-processes the stored string at render time so the fix
 * is immediate — no re-translate required.
 *
 * Languages where Latin "h" is the commonly-accepted travel shorthand
 * (en, es, fr, de, it, pt, ca, pl) are returned unchanged.
 */

// Per-language replacements for the "hours" unit. Keys: lang code.
// Values: { hour, minute } — each used as a direct replacement suffix.
const UNIT_MAP = {
  ja: { hour: '時間', minute: '分' },
  zh: { hour: '小时', minute: '分' },
  ru: { hour: ' ч', minute: ' мин' },
  uk: { hour: ' год', minute: ' хв' },
};

// Match a numeric quantity followed by an English hour/minute unit.
// Handles: 3h, 3 h, 3hr, 3hrs, 3 hour, 3 hours, 1.5h, 1,5h
const HOUR_RE = /(\d+(?:[.,]\d+)?)\s*(?:hours?|hrs?|h)\b/gi;
const MIN_RE = /(\d+(?:[.,]\d+)?)\s*(?:minutes?|mins?|min)\b/gi;

export function formatDuration(text, lang) {
  if (!text) return '';
  const units = UNIT_MAP[lang];
  if (!units) return text; // Latin-script langs keep the stored string as-is
  return text
    .replace(HOUR_RE, (_, qty) => `${qty}${units.hour}`)
    .replace(MIN_RE, (_, qty) => `${qty}${units.minute}`);
}
